import type { ApiConfig } from '../../types'

export const tradeHistoryApiConfig = {
  existSubType: false,
  fetchableRange: undefined,
  limit: 100, // デフォルト100件
  order: 'desc', // APIは新しい順に返す
  range: undefined,
  requiresRange: false,
  type: 'trade-history',
} as const satisfies ApiConfig
